import { Cons2 } from "../../../core/assets";
import { motion } from "framer-motion";
import './preloader.css'

const Preloader = () => {
  const animationDurationForBackground = 0.5;


  return (
    <motion.section className=" flex justify-center items-center h-screen w-screen bg-black"
    initial={{ scale: 1 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0 }}
        transition={{
          type: "tween",
          stiffness: 100,
          damping: 10,
          mass:0.5,
         duration:animationDurationForBackground
        }} >
     <motion.div
      className="moving-border"
      initial={{ opacity:"0" }}
      animate={{ opacity:"1" }}
      exit={{ rotate: 5 }}
      transition={{ duration: 3, repeat: Infinity, repeatType: "loop" }}
    >
      <div className="border-container">
        <div className="border-top"></div>
        <div className="border-right"></div>
        <div className="border-bottom"></div>
        <div className="border-left"></div>
      </div>
      <img src={Cons2} alt="logo" className="w-[100px] h-[100px] md:w-[150px] md:h-[150px]" style={{ objectFit: "contain", filter: "invert(1)" }} />
    </motion.div>
    </motion.section>
  );
};

export default Preloader;
